import { connect } from 'react-redux'
import * as api from '../store/api'
import BuyTickets from '../components/BuyTickets';

const mapStateToProps = (state) => {
  return {
    client:state.service.client,
    event:state.service.event
  };
}


const mapDispatchToProps = (dispatch) => ({
  fetchEvent: (clientId, callback) => {
    dispatch(api.fetchEvent(clientId)).then(callback)
  },
  purchase: (data, callback) => {
    dispatch(api.purchase(data)).then(callback)
  }
})


export default connect(mapStateToProps, mapDispatchToProps)(BuyTickets)
